if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
            
            var quick_submitButton = document.querySelector('.quick-add-modal[open] .quick-add-modal__content-info .bundle-form__submit');
            if (quick_submitButton) {
              quick_submitButton.addEventListener("click", function(event) {
                event.preventDefault();
                var variantId = document.querySelector(".quick-add-modal[open] .quick-add-modal__content-info .bundle-product-varid").getAttribute("data-bundle-variant-id");
                var pdp_variant_id = document.querySelector(".quick-add-modal[open] .quick-add-modal__content-info .product-variant-id").value;
                const extraItem = {
                  items: [
                    {
                      id: pdp_variant_id,
                      quantity: 1
                    },
                    {
                      id: variantId,
                      quantity: 1
                    }
                  ]
                };
                bundle_changeVariant("/cart/add.js", extraItem);
              });
              function bundle_changeVariant(url, sendData) {
                // Make POST request using fetch API
                fetch(url, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(sendData),
                  mode: "cors",
                  cache: "no-cache",
                  credentials: "same-origin",
                  redirect: "follow",
                  referrerPolicy: "no-referrer",
                })
                  .then(response => {
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    return response.json();
                  })
                  .then(data => {
                    // Update cart drawer content
                    fetch("/?section_id=cart-drawer", {
                      method: "GET",
                      headers: {
                        "Content-Type": "application/json",
                      },
                    })
                      .then(response => {
                        if (!response.ok) {
                          throw new Error("Failed to fetch cart drawer content");
                        }
                        return response.text();
                      })
                      .then(carthtml => {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(carthtml, "text/html");
                        var cartDrawerHtml = doc.querySelector(".cart-drawer").innerHTML;
                        var cartDrawer = document.querySelector(".cart-drawer");
                        if (cartDrawer) {
                          cartDrawer.innerHTML = cartDrawerHtml;
                          document.querySelector("cart-drawer").classList.remove("is-empty");
                          document.querySelector("cart-drawer").classList.add("animate", "active");
                          document.querySelector("body").classList.add("overflow-hidden");
                          document.querySelector(".quick-add-modal[open] .quick-add-modal__toggle").click();
                        }
                        load_cart();
                      })
                      .catch(error => {
                        console.error("Error fetching cart drawer content:", error);
                      });
                  })
                  .catch(error => {
                    console.error("Error adding item to cart:", error);
                  });
              }
            
              function load_cart() {
                const url = "/cart.js";
                fetch(url)
                  .then(response => {
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    return response.json();
                  })
                  .then(data => {
                    var cart_count = data.item_count;
                    var cartCountBubble = document.querySelector(".cart-count-bubble span");
                    if (cartCountBubble) {
                      cartCountBubble.textContent = cart_count > 0 ? cart_count : "0";
                      document.querySelector(".cart-count-bubble").classList.remove("hidden");
                    }
                  })
                  .catch(error => {
                    console.error("Error loading cart:", error);
                  });
              }
            }
            
            // Define the Toggle class first
            class Toggle {
                constructor(toggleClass) {
                    this.el = document.querySelector(toggleClass);
                    this.tabs = Array.from(this.el.querySelectorAll('.quick-add-modal[open] .quick-add-modal__content-info .quick-tab'));
                    this.panels = Array.from(this.el.querySelectorAll('.quick-add-modal[open] .quick-add-modal__content-info .quick-panel'));
                    this.bind();
                }
            
                show(index) {
                    this.tabs.forEach(tab => tab.classList.remove('active-tab'));
                    const activeTab = this.tabs[index];
                    activeTab.classList.add('active-tab');
            
                    this.panels.forEach(panel => panel.style.display = 'none');
                    const activePanel = this.panels[index];
                    activePanel.style.display = 'block';
                }
            
                bind() {
                    this.tabs.forEach((tab, index) => {
                        tab.addEventListener('click', () => this.show(index));
                    });
                }
            }
            
            // Now you can safely create an instance of the Toggle class
            (function() {
                var quick_toggle = new Toggle('.quick-add-modal[open] .quick-add-modal__content-info .quick-toggle');
            })();

            
          });
        
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
  
    }
  );
}
